module.exports = "/images/as.svg?222a2cc21540f29e0bc8a46bf6cae62a";